import axios from "axios";

export function getAuthToken(email, password) {
  return new Promise((resolve, reject) => {
    const url = `${process.env.REACT_APP_API_HOST}/api/v1/auth/`;
    axios.post(url, {
      email: email,
      password: password,
    })
    .then((response) => {
      resolve(response);
    }
    )
    .catch((error) => {
      reject(error);
    }
    );
  }
  );
}

    